import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ErrorBoundary } from "./ErrorBoundary";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname, hash]);
  return null;
};

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-aura-base text-aura-ink">
      <ScrollManager />
      <Navbar />
      <main>
        <ErrorBoundary
          fallback={
            <div className="mx-auto max-w-xl px-6 py-40 text-center">
              <h1 className="font-heading text-3xl font-semibold text-aura-ink">Something went wrong</h1>
              <p className="mt-3 text-aura-text2">Please refresh the page. If it keeps happening, email support@auralive.me.</p>
              <button
                onClick={() => window.location.reload()}
                className="mt-6 rounded-full bg-aura-ink px-6 py-3 text-sm font-semibold text-white"
              >
                Reload
              </button>
            </div>
          }
        >
          {children}
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
};
